/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/camelcase */

import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import DynamicTextField from 'components/DynamicTextField';
import InputAdornmentChip from 'components/InputAdornmentChip';
import { Formik } from 'formik';
import i18n from 'i18n';
import { FormRequestingUserReconnectionProps } from 'modules/environments/interfaces';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import schema from './schema';
import screenFields from './screenFields';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  onCancel: () => void;
  onSubmit: (values: any) => void;
}

const initialValues: FormRequestingUserReconnectionProps = {
  disconnection_time: '5',
  operator_name: '',
  notification_email: [],
  user_message: '',
};

const FormRequestingUserReconnection = ({ onCancel, onSubmit }: Props) => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.container}
        data-testid={'autosky-formrequestinguserreconnection'}
      >
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, errors, values, submitForm }) => (
            <Grid container spacing={2}>
              <GenericForm
                fields={values}
                screenFields={screenFields.slice(0, 1)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
              <InputAdornmentChip
                {...screenFields[1]}
                values={values.notification_email}
                setFieldValue={setFieldValue}
              />
              <GenericForm
                fields={values}
                screenFields={screenFields.slice(2, 3)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
              <DynamicTextField
                {...screenFields[3]}
                setFieldValue={setFieldValue}
                value={values.user_message}
                errors={errors}
              />
              <Grid
                container
                justify="flex-end"
                className={classes.buttons}
                style={{ margin: '8px 0 0' }}
              >
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('ENVIRONMENTS_PAGE.PUBLICATIONS_KEY')}
                </Button>
                <Button
                  variant="outlined"
                  id="cancel-button"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
    </>
  );
};

export default FormRequestingUserReconnection;
